import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";
import {isNullOrUndef, isStringNullOrUndefOrEmpty} from "../../../../common";

@Component({
    selector: 'app-scene-block-clock',
    templateUrl: './block-clock.component.html',
    styleUrls: ['./block-clock.component.scss']
})
export class BlockClockComponent extends BlockBaseComponent {

    defMask = {
        date_time: 'EEEE, MMM. D, YYYY at L:NN A',
        time: 'J:NN:SS',
        date: 'MM/DD/YY',
        custom: ''
    };

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        const previousMask = this.sceneItem.Data[0].Clock[0].$.clockMask;
        super.submit(formValues);
        let value = formValues.clockFormat === 'custom' ? formValues.clockMask : this.defMask[formValues.clockFormat];
        this.setFormValue('clockMask', value);
        if (isNullOrUndef(value)) {
            value = previousMask ? previousMask : '? ? ? ';
            this.setFormValue('clockMask', value);
        }
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'clockMask',
                value,
                storePath: 'Data[0].Clock[0].$'
            }]
        });
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.sceneItem.Data[0].Clock[0].$.clockFormat === 'custom' ? this.setUiDisableInput('clockMask', false) : this.setUiDisableInput('clockMask', true);
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.mask', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "clockMask",
                disabled: this.sceneItem.Data[0].Clock[0].$.clockFormat !== 'custom',
                storePath: 'Data[0].Clock[0].$.clockMask'
            },
            {
                type: "select",
                label: this.translocoService.translate('general.type', {}, this.translocoService.getActiveLang()),
                name: "clockFormat",
                value: "time",
                options: ["date_time", "date", "time", "custom"],
                storePath: 'Data[0].Clock[0].$.clockFormat'
            }

            // ,{
            //   type: "checkbox",
            //   value: '1',
            //   label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //   name: "gpu",
            //   storePath: '$.gpu'
            // }
        ];
    }
}

